import React from 'react';
import PropTypes from 'prop-types';

class Cropper extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line global-require
    this.state = { Draggabilly: require('draggabilly') };

    this.initializeCrop = this.props.initializeCrop.bind(
      this,
      this.state.Draggabilly,
    );
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-string-refs
    this.initializeCrop(this.refs);
  }

  crop(uploadedImage, index) {
    // eslint-disable-next-line react/no-string-refs
    this.props.crop(uploadedImage, index, this.refs);
  }

  render() {
    return (
      <div className="modal no-select">
        <div className="modal-inner no-select">
          <div className="crop-border no-select">
            {/* eslint-disable react/no-string-refs */}
            <div className="crop-container no-select" ref="crop-container">
              {/* eslint-enable react/no-string-refs */}
              {/* eslint-disable jsx-a11y/alt-text */}
              {/* eslint-disable react/no-string-refs */}
              <img
                className="original no-select"
                ref="target-image"
                src={this.props.uploadedImage.url}
                title="Cropping..."
              />
              {/* eslint-enable jsx-a11y/alt-text */}
              <div className="crop-btns no-select">
                {/* eslint-disable jsx-a11y/no-autofocus */}
                <button
                  className="cancel"
                  ref="cancel-crop-button"
                  tabIndex="0"
                  autoFocus
                  onClick={() => this.props.displayModal('')}
                >
                  {this.props.translations.cancel}
                </button>
                {/* eslint-enable jsx-a11y/no-autofocus */}
                <button
                  className="image-crop"
                  ref="crop-button"
                  tabIndex="0"
                  onClick={() =>
                    this.crop(this.props.uploadedImage.url, this.props.index)
                  }
                >
                  {this.props.translations.done}
                </button>
              </div>
              <div className="overlay no-select" ref="crop-zone">
                <div className="dragger no-select" draggable="true" />
                <div
                  className="handle nw no-select"
                  ref="nw-handle"
                  draggable="true"
                />
                <div
                  className="handle se no-select"
                  ref="se-handle"
                  draggable="true"
                />
              </div>
              {/* eslint-enable react/no-string-refs */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Cropper.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  uploadedImage: PropTypes.shape({ url: PropTypes.string }).isRequired,
  index: PropTypes.number.isRequired,
  displayModal: PropTypes.func.isRequired,
  initializeCrop: PropTypes.func.isRequired,
  crop: PropTypes.func.isRequired,
};

export default Cropper;
